import React from 'react';
const IconActionFlagFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.05016 15L9.78016 13H16.6602L13.7502 21H15.8802L22.4302 3H11.3002L10.5702 5H5.30016L1.66016 15H9.05016Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconActionFlagFill;